<template>
    <div class="form form-wrap">

        <div class="form-field-input-2">
            <label>Фамилия</label>
            <div class="field-input-wrapper">
                <input v-model="client.surname" type="text" disabled>
            </div>
        </div>
        <div class="form-field-input-2">
            <label>Имя и Отчество</label>
            <div class="field-input-wrapper">
                <input v-model="nameAndPatronymic" type="text" disabled>
            </div>
        </div>
        <div class="form-field-input-2">
            <label>Email</label>
            <div class="field-input-wrapper">
                <input v-model="client.email" type="email" disabled>
            </div>
        </div>
        <div class="form-field-input-2 disabled">
            <label>Номер телефона</label>
            <div class="field-input-wrapper">
                <!--<input v-model="client.phone" type="text" class="phone-num" disabled>-->
                <vue-tel-input v-model="client.phone"
                               name="phone"
                               @country-changed="countryChanged"
                               @validate="phoneValidate"
                               :disabled="true"
                               ref="phoneNumber"
                ></vue-tel-input>
            </div>
        </div>
        <div v-for="link in client.linkList" class="form-field-input-2">
            <label>Дополнительный канал связи</label>
            <div class="field-input-wrapper">
                <input v-model="link.data" type="text" disabled>
            </div>
        </div>

    </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';

export default {
    name: "ClientPersonal",
    components: {VueTelInput},
    props: ["client"],
    data() {
        return {
            intlTelNumber: {},
            intlTelCountry: {},
            defaultCountry: 'RU'
        }
    },
    computed: {
        nameAndPatronymic() {
            return this.client.name + ' ' + this.client.patronymic;
        }
    },
    methods: {
        countryChanged(country) {
            this.intlTelCountry = country;
            this.defaultCountry = country.iso2;
            this.$refs.phoneNumber.choose(this.defaultCountry);

            if (this.client.phone && this.client.phone.includes("+")) {
                this.client.phone = this.client.phone.replace("+".concat(country.dialCode), "");
            }
        },
        phoneValidate(tel) {
            this.intlTelNumber = {number: tel.number, isValid: tel.isValid};
            if (tel.isValid) {
                this.defaultCountry = tel.regionCode;
                this.$refs.phoneNumber.choose(tel.regionCode);
            }

            if (tel.number.international) {
                let index = tel.number.international.indexOf(" ");
                this.client.phone = tel.number.international.slice(index + 1);
            }
        },
    }
}
</script>

<style>

</style>